import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { AdminPlaceholder } from '@/components/admin/AdminPlaceholder';
import {
  CalendarRange,
  CreditCard,
  Globe2,
  Settings,
  Shield,
  Trophy,
  Users,
  Video,
  Wallet,
} from 'lucide-react';

const PLACEHOLDERS = {
  sports: {
    title: 'Deportes',
    phase: '02',
    icon: Trophy,
    description:
      'Gestión de catálogo de deportes (alta, edición, activación). El seed actual ya contiene Fútbol, Baloncesto y Voleibol como base.',
    bullets: [
      'CRUD de deportes con icono y orden de visualización.',
      'Activación/desactivación por territorio.',
      'Filtros por deporte en páginas públicas.',
    ],
  },
  territories: {
    title: 'Territorios',
    phase: '02',
    icon: Globe2,
    description:
      'Jerarquía geográfica (país → región → provincia → ciudad). El seed actual incluye España > Andalucía > Cádiz.',
    bullets: [
      'Gestión de árbol jerárquico de territorios.',
      'Asociación de clubes y eventos a territorio.',
      'Filtros geográficos para usuarios finales.',
    ],
  },
  clubes: {
    title: 'Clubes',
    phase: '02',
    icon: Shield,
    description:
      'Gestión de clubes (alta, edición, escudo, datos federativos, equipos asociados). Seed actual: 4 clubes de Cádiz.',
    bullets: [
      'CRUD completo de clubes con escudo, colores y federación.',
      'Vinculación con equipos y eventos.',
      'Roles club_admin y gestión delegada.',
    ],
  },
  equipos: {
    title: 'Equipos',
    phase: '02',
    icon: Users,
    description:
      'Categorías y plantillas de cada club (Senior, Juvenil, Cadete, Infantil, Alevín, Benjamín).',
    bullets: [
      'CRUD de equipos por club y categoría.',
      'Plantilla con jugadores y staff.',
      'Configuración de canal/marca por equipo.',
    ],
  },
  eventos: {
    title: 'Partidos',
    phase: '03',
    icon: CalendarRange,
    description:
      'Calendario de partidos, programación de directos y publicación de eventos. Seed actual: 2 eventos demo.',
    bullets: [
      'CRUD de eventos con sedes, horarios y rivales.',
      'Estados: borrador, publicado, programado en directo, en directo, finalizado.',
      'Reglas de acceso (gratuito, PPV, suscripción).',
    ],
  },
  planes: {
    title: 'Planes',
    phase: '04',
    icon: Wallet,
    description:
      'Planes de suscripción y compras puntuales. Seed actual: 1 plan demo (NetScouters Premium mensual).',
    bullets: [
      'CRUD de planes, precios y periodicidad.',
      'Compras puntuales (pay-per-event) y suscripciones.',
      'Asignación de entitlements a contenidos.',
    ],
  },
  pagos: {
    title: 'Pagos',
    phase: '04',
    icon: CreditCard,
    description:
      'Operaciones económicas: compras, suscripciones, devoluciones e historial. Integración con pasarela en Fase 04.',
    bullets: [
      'Listado de transacciones y estados.',
      'Reembolsos y conciliación.',
      'Reportes básicos de ingresos.',
    ],
  },
  videos: {
    title: 'Contenidos',
    phase: '06A',
    icon: Video,
    description:
      'Catálogo VOD y vídeo bajo demanda. Cuando se active el módulo, se conectará a un proveedor de hosting/streaming.',
    bullets: [
      'Subida y procesado de vídeos.',
      'Catálogo on-demand asociado a eventos.',
      'Reproductor adaptativo con DRM ligero.',
    ],
  },
  configuracion: {
    title: 'Configuración',
    phase: '04',
    icon: Settings,
    description:
      'Parámetros globales del backoffice: idiomas, monedas, branding por territorio, integraciones y banners.',
    bullets: [
      'Branding global y por club.',
      'Configuración de integraciones (pagos, vídeo, email).',
      'Feature flags por entorno.',
    ],
  },
};

export function makeAdminPlaceholderPage(key) {
  const cfg = PLACEHOLDERS[key];
  return function Page() {
    return (
      <AdminLayout>
        <AdminPlaceholder
          title={cfg.title}
          phase={cfg.phase}
          icon={cfg.icon}
          description={cfg.description}
          bullets={cfg.bullets}
          testId={`admin-placeholder-${key}`}
        />
      </AdminLayout>
    );
  };
}

export const AdminSportsPage = makeAdminPlaceholderPage('sports');
export const AdminTerritoriesPage = makeAdminPlaceholderPage('territories');
export const AdminClubsPage = makeAdminPlaceholderPage('clubes');
export const AdminTeamsPage = makeAdminPlaceholderPage('equipos');
export const AdminEventsPage = makeAdminPlaceholderPage('eventos');
export const AdminPlansPage = makeAdminPlaceholderPage('planes');
export const AdminPaymentsPage = makeAdminPlaceholderPage('pagos');
export const AdminVideosPage = makeAdminPlaceholderPage('videos');
export const AdminSettingsPage = makeAdminPlaceholderPage('configuracion');
